import * as types from "../../constants";

export default function reducer(state = {}, actions) {
  function removeItemFromArray(arr, value) {
    let index = -1;
    arr.map((item) => {
      if (value.id === item.id) {
        index = arr.indexOf(item);
      }
      return item;
    });
    if (index !== -1) {
      arr.splice(index, 1);
    }
    return arr;
  }
  switch (actions.type) {
    case types.FETCH_OPERATOR_PENDING:
      return {
        ...state,
        pending: true,
        operator: [],
      };
    case types.FETCH_OPERATOR_SUCCESS:
      return {
        ...state,
        pending: false,
        operator: actions.payload,
      };
    case types.FETCH_OPERATOR_ERROR:
      return {
        ...state,
        pending: false,
        error: actions.error,
      };

    case types.FETCH_OPERATORS_PENDING:
      return {
        ...state,
        pending: true,
        operators: [],
      };
    case types.FETCH_OPERATORS_SUCCESS:
      return {
        ...state,
        pending: false,
        operators: actions.payload,
      };
    case types.FETCH_OPERATORS_ERROR:
      return {
        ...state,
        pending: false,
        error: actions.error,
      };
    case types.UPDATE_OPERATOR_PENDING:
      return {
        ...state,
        pending: true,
      };
    case types.UPDATE_OPERATOR_SUCCESS:
      return {
        ...state,
        pending: false,
        operators: state.operators.map((item) => {
          if (actions.payload.data.value.id === item.id) {
            item = { ...actions.payload.data.value };
          }
          return item;
        }),
        // actions.payload,
      };
    case types.UPDATE_OPERATOR_ERROR:
      return {
        ...state,
        pending: false,
        error: actions.error,
      };
    case types.INSERT_OPERATOR_PENDING:
      return {
        ...state,
        pending: true,
      };
    case types.INSERT_OPERATOR_SUCCESS:
      return {
        ...state,
        pending: false,
        operators: [...state.operators, actions.payload.data.value],
        // actions.payload,
      };
    case types.INSERT_OPERATOR_ERROR:
      return {
        ...state,
        pending: false,
        error: actions.error,
      };
    case types.REMOVE_OPERATOR_PENDING:
      return {
        ...state,
        pending: true,
      };
    case types.REMOVE_OPERATOR_SUCCESS:
      return {
        ...state,
        pending: false,
        operators: removeItemFromArray(
          state.operators,
          actions.payload.data.value
        ),
      };
    case types.REMOVE_OPERATOR_ERROR:
      return {
        ...state,
        pending: false,
        error: actions.error,
      };

    default:
      return state;
  }
}
